module.exports = __webpack_public_path__ + "img/owner.5eff983f.png";